export * from './inspecao.controller';
